<app-default-layout
  [title]="'STANDARD.TICKET_ANTRAEGE'"
  >

  <div class="topbar">
    <div class="row">
      <div class="col-md-10 offset-md-1 col-lg-8 offset-lg-2 ml-auto">
        <button class="btn btn-primary float-end"
          (click) = createNewEntwurf()
          data-cy="add-antragticket"
          >
          <fa-icon [icon]="faPlus"></fa-icon>
          {{ "TICKET-TABLE.ADDBUTTON" | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-10 offset-md-1  col-lg-8 offset-lg-2">
      <div class="frame frame-default">

        <div class="mobile-table">
          @if (isLoading) {
            <div class="text-center py-4">
              <div class="loader mx-auto"></div>
              <div class="mt-3">{{'NGX_DATATABLE.LOADING' | translate}}</div>
            </div>
          }

          @if (!isLoading && (!rows || rows.length === 0)) {
            <div class="text-center py-4">
              {{'NGX_DATATABLE.EMPTY' | translate}}
            </div>
          }

          @for (row of rows; track row) {
            <div class="ticket-card" (click)="navigateToDetail(row.id)">
              <div class="ticket-card-header">
                <strong>{{ row.name }}, {{ row.vorname }}</strong>
                <span class="badge" [ngClass]="getStatusBadgeClass(row.status)">
                  {{ "TICKET-TABLE.STATUS."+row.status | translate }}
                </span>
              </div>
              <div class="ticket-card-body">
                <div class="ticket-card-item">
                  <span class="ticket-card-label">{{ "TICKET-TABLE.COLUMNS.schule" | translate }}:</span>
                  <span class="ticket-card-value">{{ row.schuleName || '-' }}</span>
                </div>
                <div class="ticket-card-item">
                  <span class="ticket-card-label">{{ "TICKET-TABLE.COLUMNS.schuljahr" | translate }}:</span>
                  <span class="ticket-card-value">{{ row.schuljahrName || '-' }}</span>
                </div>
                <div class="ticket-card-item">
                  <span class="ticket-card-label">{{ "TICKET-TABLE.COLUMNS.antragsdatum" | translate }}:</span>
                  <span class="ticket-card-value">{{ row.antragsdatum | date:'dd.MM.yyyy' }}</span>
                </div>
              </div>
            </div>
          }

          @if (!isLoading && dataFetched) {
            <div class="mobile-footer">
              <strong>{{ rows.length }}</strong> {{'NGX_DATATABLE.TOTAL' | translate}}
            </div>
          }
        </div>

        <ng-template #hdrTpl let-column="column" let-sort="sortFn">
          <div (click)="sort()">
            <fa-icon
              [icon]="this.sortInitial" >
            </fa-icon>
            <span style="padding-right:.5rem;">
              <strong> {{ "TICKET-TABLE.COLUMNS."+column.name | translate }}</strong>
            </span>
          </div>
        </ng-template>

      </div>
    </div>
  </div>


</app-default-layout>

